import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetImsVendorLoadData } from '@/api/MaintainDeliveryNote2';
import util from '@/libs/util';
export default {
  props: {
    isShowOutsourcedChangeVendorDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      loading: false,
      pageInfo: {
        TotalCount: null,
        Page: 1,
        Limit: 10
      },
      keyWord: null
    };
  },
  methods: {
    handleSearch: function handleSearch() {
      this.keyWord = this.keyWord.trim();
      this.GetVendorList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageInfo.Page = value;
      this.GetVendorList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.pageInfo.Limit = value;
      this.GetVendorList();
    },
    // 选择行
    currentChange: function currentChange(_ref) {
      var newValue = _ref.newValue,
          oldValue = _ref.oldValue,
          row = _ref.row,
          rowIndex = _ref.rowIndex,
          $rowIndex = _ref.$rowIndex,
          column = _ref.column,
          columnIndex = _ref.columnIndex,
          $columnIndex = _ref.$columnIndex,
          $event = _ref.$event;
      // console.log(row);
      // console.log(rowIndex);
      // console.log($rowIndex);
      this.$refs.xTable.setRadioRow(this.tabelData[rowIndex]);
    },
    // 行样式
    rowClassName: function rowClassName() {
      return 'rowClass';
    },
    GetVendorList: function GetVendorList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Page: _this.pageInfo.Page,
                  Limit: _this.pageInfo.Limit,
                  Key: _this.keyWord
                };
                _this.loading = true;
                _context.next = 4;
                return GetImsVendorLoadData(params);

              case 4:
                res = _context.sent;
                _this.loading = false;
                console.log('供应商列表 res', res);

                if (res.code === 0) {
                  _this.tabelData = res.data.Items;
                  _this.pageInfo.TotalCount = res.data.TotalCount;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$emit('closeChangeVendorDialog', false);
    },
    handleDelSubmit: function handleDelSubmit() {
      var selectRecords = this.$refs.xTable.getRadioRecord(); // console.log('selectRecords',selectRecords);

      this.$emit('cbDialogSubmit', {
        vendorObj: selectRecords,
        dialogData: this.tabelData
      });
      this.$emit('closeChangeVendorDialog', false);
    }
  }
};